export default "__VITE_ASSET__sPJhNQHw__"